import hoistNonReactStatics from 'hoist-non-react-statics';
import { isUndefined } from 'lodash';
import React, { useContext, useEffect, useMemo } from 'react';
import { FilterHidingContext } from '../helpers/FilterHidingContext';
const withFilterHiding = (Component) => {
    const Hoc = ({ isVisible: isVisibleProps, isHidingEnabled = false, ...props }) => {
        const { isVisible, registerFilter, hasFilterBar } = useContext(FilterHidingContext);
        useEffect(() => {
            if (registerFilter && isHidingEnabled) {
                registerFilter();
            }
        }, [registerFilter, isHidingEnabled]);
        const _isVisible = useMemo(() => {
            if (!isUndefined(isVisibleProps)) {
                return isVisibleProps;
            }
            if (!hasFilterBar) {
                return true;
            }
            return isVisible;
        }, [isVisibleProps, isVisible, hasFilterBar]);
        return <Component {...props} isVisible={_isVisible}/>;
    };
    Hoc.displayName = `withFilterHiding(${Component.displayName || Component.name}`;
    return hoistNonReactStatics(Hoc, Component);
};
export default withFilterHiding;
